export enum E_FloatingWidgetTriggerLocation {
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
}

export enum E_FloatingWidgetMessageLocation {
  RIGHT = 'right',
  LEFT = 'left',
  ABOVE = 'above',
}

export enum E_FloatingWidgetMobileMessageLocation {
  ABOVE = 'above',
  BELOW = 'below',
}
